import { render, staticRenderFns } from "./LegalRb.vue?vue&type=template&id=c786c012&scoped=true&"
import script from "./LegalRb.vue?vue&type=script&lang=js&"
export * from "./LegalRb.vue?vue&type=script&lang=js&"
import style0 from "./LegalRb.vue?vue&type=style&index=0&id=c786c012&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c786c012",
  null
  
)

export default component.exports